import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteFiles = ({ caseId, matterId }: { caseId: string; matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (fileIds: string[]) => {
      const data = {
        fileIds: fileIds,
        caseId,
      };
      const fetchConfig = getFetchConfig({ method: FetchMethod.DELETE, data });

      const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/files`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to delete files');
      }
    },
    {
      onError: () => {
        toast.error('Failed to delete files');
      },
      onSettled: () => {
        queryClient.invalidateQueries([QueryEntity.Files, { matterId }]);
        queryClient.invalidateQueries([QueryEntity.UploadHistory, { matterId }]);
        queryClient.invalidateQueries([QueryEntity.DeletedFiles, { matterId }]);
      },
    },
  );
};
